<template>
  <Head>
    <Link v-if="bgSrc" rel="preload" :href="props.bgSrc" as="image" />
    <Title>{{ props.title }}</Title>
  </Head>

  <NavBar />

  <section
    :class="twMerge('bg-cover bg-center min-h-[60vw] md:min-h-[60vh] pt-36 bg-slate-500 text-white flex flex-col justify-center bg-blend-multiply', props.class)"
    :style="{ backgroundImage: bgSrc ? `url(${props.bgSrc})` : undefined, backgroundPosition: bgPosition }"
  >
    <div :class="twMerge('container text-center drop-shadow', props.containerClass)">
      <h1>{{ props.title }}</h1>
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

const props = defineProps<{
  class?: string
  bgPosition?: string
  containerClass?: string
  bgSrc?: string
  title: string
}>()
</script>
